<template>
  <section class="flex flex-col gap-4" data-testid="txn-analytics-result">
    <h3 class="text-xl font-medium">{{ t('messages.transactions.analytics.result.title') }}</h3>

    <!-- LOADING: the real table shell with skeleton rows so nothing jumps -->
    <div v-if="store.state === 'LOADING'" class="flex flex-col gap-4" data-testid="txn-analytics-state-loading">
      <div class="flex flex-col gap-2">
        <Skeleton width="18rem" height="1.25rem" />
        <Skeleton width="12rem" height="0.9rem" />
      </div>
      <PriceStatisticsTable loading />
    </div>

    <!-- RESULT / RESULT_PARTIAL (+ RED-370 per-region table when 2+ regions are picked) -->
    <template v-else-if="hasTable">
      <ResultSummaryBox :result="store.result">
        <ResultActions />
        <PeriodComparisonTable v-if="store.isComparison" :periods="store.result.periods" :table="store.result.table" />
        <PriceStatisticsTable
          v-else
          :period="store.result.periods[0]"
          :table="store.result.table"
          :columns="store.result.columns"
        />
      </ResultSummaryBox>
      <RegionStatisticsTable v-if="store.hasRegions" />
    </template>

    <!-- IDLE / TOO_FEW / EMPTY / TOO_MANY / ERROR -->
    <ResultStatePanel v-else />
  </section>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useAnalyticsStore } from '@/stores/analyticsStore'
import PriceStatisticsTable from './PriceStatisticsTable.vue'
import PeriodComparisonTable from './PeriodComparisonTable.vue'
import RegionStatisticsTable from './RegionStatisticsTable.vue'
import ResultActions from './ResultActions.vue'
import ResultSummaryBox from './ResultSummaryBox.vue'
import ResultStatePanel from './ResultStatePanel.vue'

/**
 * RED-310 — zone B ("Tulemus") of the Analüütika drawer. Switches on the
 * store's state machine (design-spec §6): the table states render the report
 * sheet, LOADING keeps the table shell with skeletons, everything else is a
 * ResultStatePanel. The drawer/form thread mounts this below the form.
 */
const { t } = useI18n()
const store = useAnalyticsStore()

const hasTable = computed(
  () =>
    (store.state === 'RESULT' || store.state === 'RESULT_PARTIAL') &&
    Array.isArray(store.result?.periods) &&
    store.result.periods.length > 0,
)
</script>
